module.exports = __webpack_public_path__ + "img/chatV.3b579bb.svg";